"use client";

import { cn } from "@postcheesy/core-utils";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

const headingVariants = cva("", {
  variants: {
    variant: {
      default: "",
      medium: "font-medium",
      semiBold: "font-semibold",
      bold: "font-bold",
      muted: "text-muted-foreground",
    },
    size: {
      h1: "text-5xl md:text-6xl",
      h2: "text-4xl md:text-5xl",
      h3: "text-3xl md:text-4xl",
      h4: "text-xl",
      h5: "text-lg",
      default: "text-lg",
    },
    colors: {
      default: "",
      muted: "text-muted-foreground",
      primary: "text-primary",
      secondary: "text-secondary",
      reversed: "text-primary-foreground",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "h1",
    colors: "default",
  },
});

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {
  asChild?: boolean;
  as?: any;
}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, variant, size, as, colors, ...props }, ref) => {
    let type: keyof React.ReactHTML;

    switch (size) {
      case "h1": {
        type = as ? as : "h1";
        break;
      }
      case "h2": {
        type = as ? as : "h2";
        break;
      }
      case "h3": {
        type = as ? as : "h3";
        break;
      }
      case "h4": {
        type = as ? as : "h4";
        break;
      }
      case "h5": {
        type = as ? as : "h5";
        break;
      }
      default: {
        type = as ? as : "h1";
        break;
      }
    }

    return React.createElement(type, {
      ref: ref,
      className: cn(headingVariants({ size, variant, colors, className })),
      ...props,
    });
  },
);
Heading.displayName = "Heading";

export { Heading, headingVariants };
